type NonNullableFields<T> = {
  [K in keyof T]: NonNullable<T[K]>
}

export const ensureAllFieldsDefined = <T extends object>(
  data: T,
  onMissing: (key: string, field: null | undefined) => string = (key, field) => {
    throw new Error(`Missing key: ${key} is ${field}`)
  },
): NonNullableFields<T> => {
  for (const [key, field] of Object.entries(data)) {
    if (field === undefined || field === null) {
      onMissing(key, field)
    }
  }

  return data as NonNullableFields<T>
}
